import { Button, Card, Col, Row } from 'antd';
import { Title } from "./Global/Title";
import { Enviorment } from "./Cards/Enviorment";
import { LightingAndWifi } from "./Cards/LightingAndWifi";
import React, { useEffect, useState } from "react";
import { InfoCircleTwoTone, RetweetOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

//["xs","sm","md","lg"]
export const WallboardTwo = () => {
    const [isLigthingOrWifi, setisLigthingOrWifi] = useState('Iluminação');
    const [buttonIsVisible, setButtonIsVisible] = useState(false);
    let timeout;
    const navigate = useNavigate();

    const showButton = () => {
        if (!buttonIsVisible) setButtonIsVisible(true);
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setButtonIsVisible(false);
        }, 3000); // Esconde o botão após 3000 milissegundos de inatividade
    };

    useEffect(() => {
        window.addEventListener('mousemove', showButton);
        window.addEventListener('scroll', showButton);
        window.addEventListener('keypress', showButton);

        return () => {
            window.removeEventListener('mousemove', showButton);
            window.removeEventListener('scroll', showButton);
            window.removeEventListener('keypress', showButton);
            clearTimeout(timeout);
        };
    }, [buttonIsVisible]);

    function changeToLightingOrWifi(value) {
        setisLigthingOrWifi(value);
    }

    return (
        <div className="site-card-wrapper">
            {buttonIsVisible && (
                <Button type="primary" shape="circle" icon={<RetweetOutlined />}
                    onClick={() => {navigate('/wallboard')}}
                    style={{
                        position: 'fixed',
                        right: '20px',
                        top: '20px',
                        zIndex: 1000
                    }} />
            )}
            <Row gutter={16} style={{ padding: '2px', margin: '0', height: '98%' }}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }} style={{ height: '100%' }} className="col_card">
                    <Card title={<Title bgTitle='green'>Ambiente</Title>} className='cardDominion' headStyle={{ backgroundColor: 'green', height: '10%' }} bodyStyle={{ display: 'flex', height: '90%', padding: '2px' }}>
                        <Enviorment />
                    </Card>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }} style={{ height: '100%' }} className="col_card">
                    <Card title={<Title bgTitle='#ffc000'>{isLigthingOrWifi}</Title>} className='cardDominion' headStyle={{ backgroundColor: '#ffc000', height: '10%' }} bodyStyle={{ display: 'flex', height: '90%', padding: '2px' }}>
                        <LightingAndWifi changeToLightingOrWifi={changeToLightingOrWifi} />
                    </Card>
                </Col>
            </Row>
            <div style={{ height: '2%', fontSize: 'small', fontWeight: 'bold', alignContent: 'baseline', marginLeft: '20px' }}>
                <InfoCircleTwoTone /><span style={{ color: 'black' }}> Dados de Domingo a Sábado</span>
            </div>
        </div>
    )
}